import { Product } from '../Pages/ResponsivePages/MobileMagazines';

/** Split result for two-line magazine titles */
export type FormattedMagazineTitle =
    | { kind: 'split'; line1: string; line2: string }
    | { kind: 'single'; text: string }
    | { kind: 'fallback'; text: string };

/**
 * Format magazine title for display.
 * Geet Govind uses parentheses; Kalyan / Kalpataru have no "(" —
 * Kalyan splits on वर्ष|varsh|year, Kalpataru on year.
 * Note: do not use \\b after Devanagari — JS word-boundary is ASCII-only and fails for वर्ष.
 */
export const formatMagazineTitle = (
    rawName: string | undefined | null,
    productType?: number
): FormattedMagazineTitle => {
    const name = String(rawName || '').trim();
    if (!name) {
        return { kind: 'fallback', text: 'Untitled Magazine' };
    }

    // Geet Govind / monthly magazines — split on opening parenthesis
    if (name.includes('(')) {
        const line1 = name.split('(')[0].trim();
        const line2 = `(${name.split('(')[1]}`;
        return { kind: 'split', line1, line2 };
    }

    // Kalyan — split before वर्ष / varsh / year (no "(" in these titles)
    if (productType === Product.Kalyan) {
        const varshMatch = name.match(/\s*(वर्ष|varsh|year)(?=\s|$|\d)/i);
        if (varshMatch && varshMatch.index != null) {
            const line1 = name.slice(0, varshMatch.index).trim();
            const line2 = name.slice(varshMatch.index).trim();
            return { kind: 'split', line1, line2 };
        }
    }

    // Kalpataru — titles like "Kalyana Kalpataru Year 1 Part 2" (no "(")
    if (productType === Product.KalyanKalpataru) {
        const yearMatch = name.match(/\s*year(?=\s|$|\d)/i);
        if (yearMatch && yearMatch.index != null) {
            const line1 = name.slice(0, yearMatch.index).trim();
            const line2 = name.slice(yearMatch.index).trim();
            return { kind: 'split', line1, line2 };
        }
    }

    return { kind: 'single', text: name };
};

/** Resolve display label from API fields (name preferred, title / slug fallback) */
export const getMagazineDisplayName = (magazine: any): string => {
    const fromFields = String(
        magazine?.name || magazine?.title || magazine?.Name || magazine?.bookName || ''
    ).trim();
    if (fromFields) return fromFields;

    // Last resort: humanize slug when related API returns empty name (e.g. lang=hi)
    const slug = String(magazine?.slug || '').trim();
    if (!slug) return '';
    return slug.replace(/[-_]+/g, ' ').trim();
};
